<template>
  <div class="container">
    <!-- <div class="leftbars">
      <div class="bar" @click="clickdingdan(0)" :class="{ 'barb': msgk === 0 }">投标订单</div>
      <div class="bar" @click="clickdingdan(1)" :class="{ 'barb': msgk === 1 }">合同履约订单</div>
      <div class="bar" @click="clickdingdan(2)" :class="{ 'barb': msgk === 2 }">预付款订单</div>
      <div class="bar" @click="clickdingdan(3)" :class="{ 'barb': msgk === 3 }">农民工工资支付订单</div>
      <div class="bar" @click="clickdingdan(4)" :class="{ 'barb': msgk === 4 }">工程款支付订单</div>
    </div> -->
    <div class="maincons">
      <div class="buzhou" v-show="msgk === 0">
        <div class="dottits">投标订单</div>
        <div class="wrap">
          <!-- 搜索版块 -->
          <el-form ref="form" class="search-form">
            <el-row :gutter="10">
              <el-col :span="3">
                <div>
                  <el-button type="success" icon="el-icon-s-operation" @click="exportExcel">导出Excel表格</el-button>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-item">
                  <el-input placeholder="项目名称/订单号" v-model="search.seachCode"></el-input>
                </div>
              </el-col>
              <el-col style="width: 360px">
                <el-date-picker v-model="search.riqi" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="query" style="margin-left: 10px">查询</el-button>
                <el-button type="info" @click="clearTable" style="margin-left: 3px">清空</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div style="padding: 5px 10px; background: #f8eaea">
            <p>
              付款后，如订单依然显示【待支付】，请耐心等待10分钟左右。此时系统正在生成保单，支付状态会滞后显示。请勿重复支付。如长时间未生成保单，或需要申请退保及理赔服务请拨打400-666-7151.
            </p>
          </div>
          <div class="wrap">
            <!-- 列表 -->
            <el-table border style="width: 100%" ref="multipleTable" :data="tableData.list">
              <el-table-column type="index" align="center" label="序号" width="80" :index="indexMethod"></el-table-column>
              <el-table-column prop="orderno" align="center" label="订单号"></el-table-column>
              <el-table-column prop="addtime" align="center" label="提交时间"></el-table-column>
              <el-table-column prop="itemname" align="center" label="项目名称"></el-table-column>
              <el-table-column prop="icmpName" align="center" label="保险公司名称"></el-table-column>
              <el-table-column prop="itype" align="center" :formatter="formattype" label="保函类型"></el-table-column>
              <el-table-column prop="bhtypename" align="center" label="支付类型"></el-table-column>
              <el-table-column prop="imoney" align="center" label="保费(元)"></el-table-column>
              <el-table-column prop="statename" align="center" label="订单状态"></el-table-column>
              <el-table-column prop="creattime" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="sumbitWindow(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 98 || (scope.row.state == 99 && scope.row.dstate == 4 && scope.row.bhtype == '1')" @click="ReturnWindow(scope.row)">退保</el-button>
                  <el-button type="text" v-if="scope.row.state == 3" @click="pay(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="up(scope.row)">上传缴费凭证</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.docUrl != '' && scope.row.docUrl != null))" @click="DownWindow(scope.row)">下载保单</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.invUrl != '' && scope.row.invUrl != null))" @click="fapiao(scope.row)">下载发票</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 翻页 -->
            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="tableData.total"></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="buzhou" v-show="msgk === 1">
        <div class="dottits">合同履约订单</div>
        <div class="wrap">
          <!-- 搜索版块 -->
          <el-form ref="form" class="search-form">
            <el-row :gutter="10">
              <el-col :span="3">
                <div>
                  <el-button type="success" icon="el-icon-s-operation" @click="exportExcel">导出Excel表格</el-button>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-item">
                  <el-input placeholder="项目名称/订单号" v-model="search.seachCode"></el-input>
                </div>
              </el-col>
              <el-col style="width: 360px">
                <el-date-picker v-model="search.riqi" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="query" style="margin-left: 10px">查询</el-button>
                <el-button type="info" @click="clearTable" style="margin-left: 3px">清空</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div style="padding: 5px 10px; background: #f8eaea">
            <p>
              付款后，如订单依然显示【待支付】，请耐心等待10分钟左右。此时系统正在生成保单，支付状态会滞后显示。请勿重复支付。如长时间未生成保单，或需要申请退保及理赔服务请拨打400-666-7151.
            </p>
          </div>
          <div class="wrap">
            <!-- 列表 -->
            <el-table border style="width: 100%" ref="multipleTable" :data="tableData.list">
              <el-table-column type="index" align="center" label="序号" width="80" :index="indexMethod"></el-table-column>
              <el-table-column prop="orderno" align="center" label="订单号"></el-table-column>
              <el-table-column prop="addtime" align="center" label="提交时间"></el-table-column>
              <el-table-column prop="itemname" align="center" label="项目名称"></el-table-column>
              <el-table-column prop="icmpName" align="center" label="保险公司名称"></el-table-column>
              <el-table-column prop="itype" align="center" :formatter="formattype" label="保函类型"></el-table-column>
              <el-table-column prop="bhtypename" align="center" label="支付类型"></el-table-column>
              <el-table-column prop="imoney" align="center" label="保费(元)"></el-table-column>
              <el-table-column prop="statename" align="center" label="订单状态"></el-table-column>
              <el-table-column prop="creattime" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="sumbitWindow(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 98 || (scope.row.state == 99 && scope.row.dstate == 4 && scope.row.bhtype == '1')
                  " @click="ReturnWindow(scope.row)">退保</el-button>
                  <el-button type="text" v-if="scope.row.state == 3" @click="pay(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="up(scope.row)">上传缴费凭证</el-button>

                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.docUrl != '' && scope.row.docUrl != null))" @click="DownWindow(scope.row)">下载保单</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.invUrl != '' && scope.row.invUrl != null))" @click="fapiao(scope.row)">下载发票</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 翻页 -->
            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="tableData.total"></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="buzhou" v-show="msgk === 2">
        <div class="dottits">预付款订单</div>
        <div class="wrap">
          <!-- 搜索版块 -->
          <el-form ref="form" class="search-form">
            <el-row :gutter="10">
              <el-col :span="3">
                <div>
                  <el-button type="success" icon="el-icon-s-operation" @click="exportExcel">导出Excel表格</el-button>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-item">
                  <el-input placeholder="项目名称/订单号" v-model="search.seachCode"></el-input>
                </div>
              </el-col>
              <el-col style="width: 360px">
                <el-date-picker v-model="search.riqi" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="query" style="margin-left: 10px">查询</el-button>
                <el-button type="info" @click="clearTable" style="margin-left: 3px">清空</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div style="padding: 5px 10px; background: #f8eaea">
            <p>
              付款后，如订单依然显示【待支付】，请耐心等待10分钟左右。此时系统正在生成保单，支付状态会滞后显示。请勿重复支付。如长时间未生成保单，或需要申请退保及理赔服务请拨打400-666-7151.
            </p>
          </div>
          <div class="wrap">
            <!-- 列表 -->
            <el-table border style="width: 100%" ref="multipleTable" :data="tableData.list">
              <el-table-column type="index" align="center" label="序号" width="80" :index="indexMethod"></el-table-column>
              <el-table-column prop="orderno" align="center" label="订单号"></el-table-column>
              <el-table-column prop="addtime" align="center" label="提交时间"></el-table-column>
              <el-table-column prop="itemname" align="center" label="项目名称"></el-table-column>
              <el-table-column prop="icmpName" align="center" label="保险公司名称"></el-table-column>
              <el-table-column prop="itype" align="center" :formatter="formattype" label="保函类型"></el-table-column>
              <el-table-column prop="bhtypename" align="center" label="支付类型"></el-table-column>
              <el-table-column prop="imoney" align="center" label="保费(元)"></el-table-column>
              <el-table-column prop="statename" align="center" label="订单状态"></el-table-column>
              <el-table-column prop="creattime" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="sumbitWindow(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="
                    scope.row.state == 98 ||
                    (scope.row.state == 99 &&
                      scope.row.dstate == 4 &&
                      scope.row.bhtype == '1')
                  " @click="ReturnWindow(scope.row)">退保</el-button>
                  <el-button type="text" v-if="scope.row.state == 3" @click="pay(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="up(scope.row)">上传缴费凭证</el-button>

                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.docUrl != '' && scope.row.docUrl != null))" @click="DownWindow(scope.row)">下载保单</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.invUrl != '' && scope.row.invUrl != null))" @click="fapiao(scope.row)">下载发票</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 翻页 -->
            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="tableData.total"></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="buzhou" v-show="msgk === 3">
        <div class="dottits">农民工工资支付订单</div>
        <div class="wrap">
          <!-- 搜索版块 -->
          <el-form ref="form" class="search-form">
            <el-row :gutter="10">
              <el-col :span="3">
                <div>
                  <el-button type="success" icon="el-icon-s-operation" @click="exportExcel">导出Excel表格</el-button>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-item">
                  <el-input placeholder="项目名称/订单号" v-model="search.seachCode"></el-input>
                </div>
              </el-col>
              <el-col style="width: 360px">
                <el-date-picker v-model="search.riqi" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="query" style="margin-left: 10px">查询</el-button>
                <el-button type="info" @click="clearTable" style="margin-left: 3px">清空</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div style="padding: 5px 10px; background: #f8eaea">
            <p>
              付款后，如订单依然显示【待支付】，请耐心等待10分钟左右。此时系统正在生成保单，支付状态会滞后显示。请勿重复支付。如长时间未生成保单，或需要申请退保及理赔服务请拨打400-666-7151.
            </p>
          </div>
          <div class="wrap">
            <!-- 列表 -->
            <el-table border style="width: 100%" ref="multipleTable" :data="tableData.list">
              <el-table-column type="index" align="center" label="序号" width="80" :index="indexMethod"></el-table-column>
              <el-table-column prop="orderno" align="center" label="订单号"></el-table-column>
              <el-table-column prop="addtime" align="center" label="提交时间"></el-table-column>
              <el-table-column prop="itemname" align="center" label="项目名称"></el-table-column>
              <el-table-column prop="icmpName" align="center" label="保险公司名称"></el-table-column>
              <el-table-column prop="itype" align="center" :formatter="formattype" label="保函类型"></el-table-column>
              <el-table-column prop="bhtypename" align="center" label="支付类型"></el-table-column>
              <el-table-column prop="imoney" align="center" label="保费(元)"></el-table-column>
              <el-table-column prop="statename" align="center" label="订单状态"></el-table-column>
              <el-table-column prop="creattime" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="sumbitWindow(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="
                    scope.row.state == 98 ||
                    (scope.row.state == 99 &&
                      scope.row.dstate == 4 &&
                      scope.row.bhtype == '1')
                  " @click="ReturnWindow(scope.row)">退保</el-button>
                  <el-button type="text" v-if="scope.row.state == 3" @click="pay(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="up(scope.row)">上传缴费凭证</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.docUrl != '' && scope.row.docUrl != null))" @click="DownWindow(scope.row)">下载保单</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.invUrl != '' && scope.row.invUrl != null))" @click="fapiao(scope.row)">下载发票</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 翻页 -->
            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="tableData.total"></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="buzhou" v-show="msgk === 4">
        <div class="dottits">工程款支付订单</div>
        <div class="wrap">
          <!-- 搜索版块 -->
          <el-form ref="form" class="search-form">
            <el-row :gutter="10">
              <el-col :span="3">
                <div>
                  <el-button type="success" icon="el-icon-s-operation" @click="exportExcel">导出Excel表格</el-button>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-item">
                  <el-input placeholder="项目名称/订单号" v-model="search.seachCode"></el-input>
                </div>
              </el-col>
              <el-col style="width: 360px">
                <el-date-picker v-model="search.riqi" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="query" style="margin-left: 10px">查询</el-button>
                <el-button type="info" @click="clearTable" style="margin-left: 3px">清空</el-button>
              </el-col>
            </el-row>
          </el-form>
          <div style="padding: 5px 10px; background: #f8eaea">
            <p>
              付款后，如订单依然显示【待支付】，请耐心等待10分钟左右。此时系统正在生成保单，支付状态会滞后显示。请勿重复支付。如长时间未生成保单，或需要申请退保及理赔服务请拨打400-666-7151.
            </p>
          </div>
          <div class="wrap">
            <!-- 列表 -->
            <el-table border style="width: 100%" ref="multipleTable" :data="tableData.list">
              <el-table-column type="index" align="center" label="序号" width="80" :index="indexMethod"></el-table-column>
              <el-table-column prop="orderno" align="center" label="订单号"></el-table-column>
              <el-table-column prop="addtime" align="center" label="提交时间"></el-table-column>
              <el-table-column prop="itemname" align="center" label="项目名称"></el-table-column>
              <el-table-column prop="icmpName" align="center" label="保险公司名称"></el-table-column>
              <el-table-column prop="itype" align="center" :formatter="formattype" label="保函类型"></el-table-column>
              <el-table-column prop="bhtypename" align="center" label="支付类型"></el-table-column>
              <el-table-column prop="imoney" align="center" label="保费(元)"></el-table-column>
              <el-table-column prop="statename" align="center" label="订单状态"></el-table-column>
              <el-table-column prop="creattime" align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="handleCheck(scope.row)">查看</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="sumbitWindow(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="
                    scope.row.state == 98 ||
                    (scope.row.state == 99 &&
                      scope.row.dstate == 4 &&
                      scope.row.bhtype == '1')
                  " @click="ReturnWindow(scope.row)">退保</el-button>
                  <el-button type="text" v-if="scope.row.state == 3" @click="pay(scope.row)">去付款</el-button>
                  <el-button type="text" v-if="scope.row.state == 2" @click="up(scope.row)">上传缴费凭证</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.docUrl != '' && scope.row.docUrl != null))" @click="DownWindow(scope.row)">下载保单</el-button>
                  <el-button type="text" v-if="(scope.row.state == 98 || scope.row.state == 99 || (scope.row.invUrl != '' && scope.row.invUrl != null))" @click="fapiao(scope.row)">下载发票</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 翻页 -->
            <div class="pagination">
              <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="tableData.total"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 退保 -->
    <el-dialog title="订单管理--退保" :visible.sync="bindVisible" width="500px">
      <el-form ref="bindform" :model="bindform" label-width="90px">
        <el-form-item label="退保原因" prop="plcApplyReason">
          <el-input type="textarea" v-model="bindform.plcApplyReason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBind" :loading="oloading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 缴费凭证 上传-->
    <el-dialog title="订单管理--上传" :visible.sync="upVisible" width="500px">
      <el-form ref="upform" :model="upform" label-width="90px">
        <el-form-item label="缴费凭证" prop="payVoucher">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="upform.payVoucher" :src="upform.payVoucher" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="upVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveUp" :loading="oloading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看 农名工保险 -->
    <el-dialog title="查看" :visible.sync="dialogFormShowVisible" width="1300px">
      <!-- 查看详情 农民工的查看 -->
      <el-form ref="check" :model="templook" class="data-formline formtemplook" label-position="right" label-width="150px">
        <table class="table">
          <!--项目信息 -->
          <tr>
            <th>农民工项目名称：</th>
            <td><span>{{ templook.itemname }}</span></td>
            <th>项目所在地：</th>
            <td><span>{{ templook.provinceName }}{{ templook.cityName }}{{ templook.areaName }}</span></td>
          </tr>

          <tr>
            <th>项目主管单位：</th>
            <td><span>{{ templook.nmgDeptName }}</span></td>
            <th>工期：</th>
            <td><span>{{ templook.commendate }}到{{ templook.completiondata }}</span></td>
          </tr>
          <tr>
            <th>保证金存储形式：</th>
            <td><span>{{ templook.nmgMean == 1 ? '按资质办理' : '按项目办理' }}</span></td>
            <!-- nmgMean ==1 才显 -->

            <th>资质类型：</th>
            <td><span>{{ templook.qualificationType1Name }}{{ templook.qualificationTypeName }}</span>
            </td>
          </tr>
          <tr>
            <th>工程项目合同价款(万元)：</th>
            <td><span>{{ templook.nmgProjectPrice }}万元</span></td>
            <th>保证金存储比例：</th>
            <td><span>{{ templook.nmgProjectRate }}%</span></td>
          </tr>
          <tr>
            <th>农民工工资保证金金额(万元)：</th>
            <td><span>{{ templook.summoney }}</span>万元<span class="redzi"> (大写：{{ dxnum }})</span></td>
            <th>被保险人：</th>
            <td><span>依法招收的农民工</span></td>
          </tr>

          <!--投保人信息-->
          <tr>
            <th>投保人名称：</th>
            <td><span>{{ templook.cmpname }}</span></td>
            <th>统一社会信用代码：</th>
            <td><span>{{ templook.buslicno }}</span></td>
          </tr>
          <!-- <tr>
                    <th>投保人类型：</th>
                    <td><span>{{templook.ttype}}</span></td>
                    <th>资质类型：</th>
                    <td><span>{{templook.qualificationType1}}</span></td>
                </tr> -->

          <!-- 农民工工资专用账户信息 -->
          <tr>
            <th>农工工资支付专用账户：</th>
            <td><span>{{ templook.accountName }}</span></td>
            <th>账号：</th>
            <td><span>{{ templook.accountNum }}</span></td>
          </tr>
          <tr>

            <th>开户行：</th>
            <td><span>{{ templook.bankName }}</span></td>
            <th>再次输入账号：</th>
            <td><span>{{ templook.accountNum }}</span></td>
          </tr>
          <!-- 反担保措施 -->
          <!-- <tr>
                    <th>反担保措施：</th>
                    <td><span>{{templook.counterguarant}}</span></td>
                    <th></th>
                    <td><span></span></td>
                </tr> -->

          <!--投保资料 -->
          <tr>
            <th>基础资料:</th>
            <td>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.buslic)" v-show="templook.buslic !== undefined && templook.buslic != ''" :href="isHttp(templook.buslic)" target="_blank">营业执照</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.cardimg2)" v-show="templook.cardimg2 !== undefined && templook.cardimg2 != ''" :href="isHttp(templook.cardimg2)" target="_blank">法人身份证正面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.cardimg1)" v-show="templook.cardimg1 !== undefined && templook.cardimg1 != ''" :href="isHttp(templook.cardimg1)" target="_blank">法人身份证背面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.prodCertificate)" v-show="templook.prodCertificate !== undefined && templook.prodCertificate != ''" :href="isHttp(templook.prodCertificate)" target="_blank">安全生产许可证</el-link>
              <!-- <span class="bluezi" @click="downTu()">安全生产许可证</span> -->
            </td>
            <th>资质证书：</th>
            <td>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enterqualifi)" v-show="templook.enterqualifi !== undefined && templook.enterqualifi != ''" :href="isHttp(templook.enterqualifi)" target="_blank">资质证书1</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enterQualifi2)" v-show="templook.enterQualifi2 !== undefined && templook.enterQualifi2 != ''" :href="isHttp(templook.enterQualifi2)" target="_blank">资质证书2</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enterQualifi3)" v-show="templook.enterQualifi3 !== undefined && templook.enterQualifi3 != ''" :href="isHttp(templook.enterQualifi3)" target="_blank">资质证书3</el-link>
            </td>
          </tr>

          <!--发票信息 -->
          <tr>
            <th>发票类型：</th>
            <td><span>{{ templook.intype == 1 ? '增值税普通发票' : '增值税专用发票' }}</span></td>
            <th>发票抬头：</th>
            <td><span>{{ templook.cmpname }}</span></td>

          </tr>
          <tr>

            <th>纳税人识别号：</th>
            <td><span>{{ templook.buslicno }}</span></td>
            <th>接收发票邮箱：</th>
            <td><span>{{ templook.invmailadd }}</span></td>
          </tr>
          <tr>

            <th>注册地址：</th>
            <td><span>{{ templook.adress }}</span></td>

            <th>开户行：</th>
            <td><span>{{ templook.bankinfo }}</span></td>
          </tr>
          <tr>
            <th>开户账号：</th>
            <td><span>{{ templook.pubaccout }}</span></td>

            <th>收件人：</th>
            <td><span>{{ templook.linman }}</span></td>
          </tr>
          <tr>
            <th>收件地址：</th>
            <td><span>{{ templook.mailadd }}</span></td>

            <th>联系电话：</th>
            <td><span>{{ templook.linephone }}</span></td>
          </tr>

          <tr>
            <th>拟投保保险公司：</th>
            <td colspan="3"><span>{{ templook.icompName }}</span></td>
          </tr>
          <tr>
            <th>投保相关文件：</th>
            <td colspan="3">
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.taxpaycertificate)" v-show="templook.taxpaycertificate !== undefined && templook.taxpaycertificate != ''" :href="isHttp(templook.taxpaycertificate)" target="_blank">施工合同电子版(关键页前五页)</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.bidnotice)" v-show="templook.bidnotice !== undefined && templook.bidnotice != ''" :href="isHttp(templook.bidnotice)" target="_blank">项目中标通知书扫描件</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.auditreport)" v-show="templook.auditreport !== undefined && templook.auditreport != ''" :href="isHttp(templook.auditreport)" target="_blank">近2年审计报告或财务报表电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enginperformance)" v-show="templook.enginperformance !== undefined && templook.enginperformance != ''" :href="isHttp(templook.enginperformance)" target="_blank">近2年财务报表电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.recordProof)" v-show="templook.recordProof !== undefined && templook.recordProof != ''" :href="isHttp(templook.recordProof)" target="_blank">四方监管协议PDF版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.otherInformation)" v-show="templook.otherInformation !== undefined && templook.otherInformation != ''" :href="isHttp(templook.otherInformation)" target="_blank">其他资料</el-link>
            </td>
          </tr>
        </table>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormShowVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="dialogOtherFormShowVisible" width="1300px">
      <!-- 查看详情   排除 投标  农民工的查看 -->
      <el-form ref="check" :model="templook" class="data-formline formtemplook" label-position="right" label-width="150px">
        <table class="table">
          <!--项目信息 -->
          <tr>
            <th>项目编号：</th>
            <td><span>{{ templook.doccode }}</span></td>
            <th>项目名称：</th>
            <td><span>{{ templook.itemname }}</span></td>
          </tr>
          <tr>
            <th>项目所在地：</th>
            <td><span>{{ templook.provinceName }}{{ templook.cityName }}{{ templook.areaName }}</span></td>
            <th>保证金额：</th>
            <td><span>{{ templook.summoney }}元</span></td>
          </tr>
          <!--被保险人信息-->
          <tr>
            <th>被保险人名称：</th>
            <td><span>{{ templook.firstCmpName }}</span></td>
            <!-- <td><span>依法招收的农民工</span></td> -->
            <th>统一社会信用代码：</th>
            <td><span>{{ templook.firstBuslicno }}</span></td>
          </tr>
          <!--投保人信息-->
          <tr>
            <th>投保人名称：</th>
            <td><span>{{ templook.cmpname }}</span></td>
            <th>统一社会信用代码：</th>
            <td><span>{{ templook.buslicno }}</span></td>
          </tr>
          <!--投保资料 -->
          <tr>
            <th>基础资料：</th>
            <td>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.buslic)" v-show="templook.buslic !== undefined && templook.buslic != ''" :href="isHttp(templook.buslic)" target="_blank">营业执照</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.cardimg2)" v-show="templook.cardimg2 !== undefined && templook.cardimg2 != ''" :href="isHttp(templook.cardimg2)" target="_blank">法人身份证正面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.cardimg1)" v-show="templook.cardimg1 !== undefined && templook.cardimg1 != ''" :href="isHttp(templook.cardimg1)" target="_blank">法人身份证背面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.openlicup)" v-show="templook.openlicup !== undefined && templook.openlicup != ''" :href="isHttp(templook.openlicup)" target="_blank">开户许可证或基本存款账户信息</el-link>
              <!-- <span class="bluezi" @click="downTu()">安全生产许可证</span> -->
            </td>
            <th>资质证书：</th>
            <td>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enterqualifi)" v-show="templook.enterqualifi !== undefined && templook.enterqualifi != ''" :href="isHttp(templook.enterqualifi)" target="_blank">资质证书1</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enterQualifi2)" v-show="templook.enterQualifi2 !== undefined && templook.enterQualifi2 != ''" :href="isHttp(templook.enterQualifi2)" target="_blank">资质证书2</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enterQualifi3)" v-show="templook.enterQualifi3 !== undefined && templook.enterQualifi3 != ''" :href="isHttp(templook.enterQualifi3)" target="_blank">资质证书3</el-link>
            </td>
          </tr>
          <tr>
            <th>投保相关文件：</th>
            <td colspan="3">
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.guaranagree)" v-show="templook.guaranagree !== undefined && templook.guaranagree != ''" :href="isHttp(templook.guaranagree)" target="_blank">反担保协议原件电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.entercreditrepor)" v-show="templook.entercreditrepor !== undefined && templook.entercreditrepor != ''" :href="isHttp(templook.entercreditrepor)" target="_blank">近3个月企业征信报告PDF版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.auditreport)" v-show="templook.auditreport !== undefined && templook.auditreport != ''" :href="isHttp(templook.auditreport)" target="_blank">近2年审计报告或财务报表电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.axpaycertificate)" v-show="templook.axpaycertificate !== undefined && templook.axpaycertificate != ''" :href="isHttp(templook.axpaycertificate)" target="_blank">施工合同电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.finanreport)" v-show="templook.finanreport !== undefined && templook.finanreport != ''" :href="isHttp(templook.finanreport)" target="_blank">招标文件电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.enginperformance)" v-show="templook.enginperformance !== undefined && templook.enginperformance != ''" :href="isHttp(templook.enginperformance)" target="_blank">工程类业绩证明电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.prolicense)" v-show="templook.prolicense !== undefined && templook.prolicense != ''" :href="isHttp(templook.prolicense)" target="_blank">安全生产许可证电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.bidnotice)" v-show="templook.bidnotice !== undefined && templook.bidnotice != ''" :href="isHttp(templook.bidnotice)" target="_blank">项目中标通知书（原件）电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.recordProof)" v-show="templook.recordProof !== undefined && templook.recordProof != ''" :href="isHttp(templook.recordProof)" target="_blank">其他资料电子版</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(templook.letterComm)" v-show="templook.letterComm !== undefined && templook.letterComm != ''" :href="isHttp(templook.letterComm)" target="_blank">承诺书电子版</el-link>
            </td>
          </tr>
          <!--发票信息 -->
          <tr>
            <th>发票类型：</th>
            <td><span>{{ templook.intype == 1 ? '增值税普通发票' : '增值税专用发票' }}</span></td>
            <th>发票抬头：</th>
            <td><span>{{ templook.cmpname }}</span></td>

          </tr>
          <tr>

            <th>纳税人识别号：</th>
            <td><span>{{ templook.buslicno }}</span></td>
            <th>接收发票邮箱：</th>
            <td><span>{{ templook.invmailadd }}</span></td>
          </tr>
          <tr>

            <th>注册地址：</th>
            <td><span>{{ templook.adress }}</span></td>

            <th>开户行：</th>
            <td><span>{{ templook.bankinfo }}</span></td>
          </tr>
          <tr>
            <th>开户账号：</th>
            <td><span>{{ templook.pubaccout }}</span></td>

            <th>收件人：</th>
            <td><span>{{ templook.linman }}</span></td>
          </tr>
          <tr>
            <th>收件地址：</th>
            <td><span>{{ templook.mailadd }}</span></td>

            <th>联系电话：</th>
            <td><span>{{ templook.linephone }}</span></td>
          </tr>

          <tr>
            <th>拟投保保险公司：</th>
            <td colspan="3"><span>{{ templook.icompName }}</span></td>
          </tr>
        </table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogOtherFormShowVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 查看 担保信息 -->
    <el-dialog el-drag-dialog title="查看" :visible.sync="dialogFormShowDanBaoVisible" width="1100px">
      <!-- 1保险 -->
      <el-form ref="check" :model="bidSecurityForm" class="data-formline formtemplook" label-position="right" label-width="150px">
        <table class="table">
          <tr>
            <th>订单号：</th>
            <td><span>{{ bidSecurityForm.orderno }}</span></td>
            <th>保单号：</th>
            <td><span>{{ bidSecurityForm.policyNo }}</span></td>
          </tr>

          <tr>
            <th>交易中心：</th>
            <td><span>{{ bidSecurityForm.incmpname }}</span></td>
            <th>担保公司：</th>
            <td><span>{{ bidSecurityForm.icompName }}</span></td>
          </tr>

          <tr>
            <th>项目所在地：</th>
            <td><span>{{ bidSecurityForm.provinceName }}{{ bidSecurityForm.cityName }}{{ bidSecurityForm.areaName
            }}</span>
            </td>

            <th>保函类型:</th>
            <td><span>{{ bidSecurityForm.bhtypename }}</span></td>
          </tr>

          <tr>
            <th>担保金额：</th>
            <td><span>{{ bidSecurityForm.bail }}元</span></td>
            <th>保费金额：</th>
            <td><span>{{ bidSecurityForm.imoney }}</span></td>
          </tr>

          <tr>
            <th>订单状态：</th>
            <td><span>{{ bidSecurityForm.stateName }}</span></td>
            <th>投保时间(添加)：</th>
            <td><span>{{ bidSecurityForm.addTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span></td>
          </tr>
          <tr>
            <th>项目编号：</th>
            <td><span>{{ bidSecurityForm.doccode }}</span></td>
            <th>项目名称：</th>
            <td><span>{{ bidSecurityForm.itemname }}</span></td>
          </tr>
          <tr>
          </tr>
          <tr>
            <th>起保日/终保日：</th>
            <td><span>{{ bidSecurityForm.istartdate | parseTime('{y}-{m}-{d}') }}—{{ bidSecurityForm.ienddate
                | parseTime('{y}-{m}-{d}')
            }}</span></td>
            <th>投标截止日期：</th>
            <td><span>{{ bidSecurityForm.enddate | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span></td>
          </tr>
          <tr>
            <th>被担保人名称：</th>
            <td><span>{{ bidSecurityForm.firstCmpName }}</span></td>
            <th>被担保险人统一社会信用代码：</th>
            <td><span>{{ bidSecurityForm.firstBuslicno }}</span></td>
          </tr>
          <tr>
            <th>投保人名称：</th>
            <td><span>{{ bidSecurityForm.cmpname }}</span></td>
            <th>投保人统一社会信用代码：</th>
            <td><span>{{ bidSecurityForm.buslicno }}</span></td>
          </tr>
          <tr>
            <th>发票类型：</th>
            <td><span>{{ bidSecurityForm.intype == 1 ? '增值税普通发票' : '增值税专用发票' }}</span></td>
            <th>发票抬头：</th>
            <td><span>{{ bidSecurityForm.cmpname }}</span></td>
          </tr>
          <tr>
            <th>纳税人识别号：</th>
            <td><span>{{ bidSecurityForm.buslicno }}</span></td>
            <th>注册地址：</th>
            <td><span>{{ bidSecurityForm.adress }}</span></td>
          </tr>
          <tr>
            <th>开户行：</th>
            <td><span>{{ bidSecurityForm.bankinfo }}</span></td>
            <th>开户账号：</th>
            <td><span>{{ bidSecurityForm.pubaccout }}</span></td>
          </tr>
          <tr>
            <th>经办人：</th>
            <td><span>{{ bidSecurityForm.insurelineman }}</span></td>
            <th>经办人电话：</th>
            <td><span>{{ bidSecurityForm.insurelinephone }}</span></td>
          </tr>
          <tr>
            <th>邮寄地址：</th>
            <td><span>{{ bidSecurityForm.mailadd }}</span></td>
            <th>接收发票邮箱：</th>
            <td><span>{{ bidSecurityForm.email }}</span></td>
          </tr>
          <tr v-if="bidSecurityForm.intype == 2">
            <th>专票上显示的电话：</th>
            <td><span>{{ bidSecurityForm.fpphone }}</span></td>
            <th>专票收件人：</th>
            <td><span>{{ bidSecurityForm.fplinmain }}</span></td>
          </tr>
          <tr>
            <th>收件人电话：</th>
            <td><span>{{ bidSecurityForm.sitcomp }}</span></td>
            <th>用途：</th>
            <td><span>{{ bidSecurityForm.remark }}</span></td>
          </tr>
          <tr>
            <th>保证金缴纳截止日期：</th>
            <td><span>{{ bidSecurityForm.endTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span></td>
          </tr>

          <tr>
            <th>基础资料：</th>
            <td v-if="bhtype == 1 || bhtype == 3 || bhtype == 5" :colspan="3">
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.buslic)" v-show="bidSecurityForm.buslic !== undefined && bidSecurityForm.buslic != ''" :href="isHttp(bidSecurityForm.buslic)" target="_blank">营业执照</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.cardimg2)" v-show="bidSecurityForm.cardimg2 !== undefined && bidSecurityForm.cardimg2 != ''" :href="isHttp(bidSecurityForm.cardimg2)" target="_blank">法人身份证正面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.cardimg1)" v-show="bidSecurityForm.cardimg1 !== undefined && bidSecurityForm.cardimg1 != ''" :href="isHttp(bidSecurityForm.cardimg1)" target="_blank">法人身份证背面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.openlicup)" v-show="bidSecurityForm.openlicup !== undefined && bidSecurityForm.openlicup != ''" :href="isHttp(bidSecurityForm.openlicup)" target="_blank">开户许可</el-link>
            </td>
            <td v-if="bhtype == 2" :colspan="3">
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.buslic)" v-show="bidSecurityForm.buslic !== undefined && bidSecurityForm.buslic != ''" :href="isHttp(bidSecurityForm.buslic)" target="_blank">营业执照</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.cardimg2)" v-show="bidSecurityForm.cardimg2 !== undefined && bidSecurityForm.cardimg2 != ''" :href="isHttp(bidSecurityForm.cardimg2)" target="_blank">法人身份证正面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.cardimg1)" v-show="bidSecurityForm.cardimg1 !== undefined && bidSecurityForm.cardimg1 != ''" :href="isHttp(bidSecurityForm.cardimg1)" target="_blank">法人身份证背面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.openlicup)" v-show="bidSecurityForm.openlicup !== undefined && bidSecurityForm.openlicup != ''" :href="isHttp(bidSecurityForm.openlicup)" target="_blank">开户许可</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.ceRepresentative)" v-show="bidSecurityForm.ceRepresentative !== undefined && bidSecurityForm.ceRepresentative != ''" :href="isHttp(bidSecurityForm.ceRepresentative)" target="_blank">法定代表人证明书(查看)</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.bidDocUrl)" v-show="bidSecurityForm.bidDocUrl !== undefined && bidSecurityForm.bidDocUrl != ''" :href="isHttp(bidSecurityForm.bidDocUrl)" target="_blank">招标文件（PDF）</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.powerAtt)" v-show="bidSecurityForm.powerAtt !== undefined && bidSecurityForm.powerAtt != ''" :href="isHttp(bidSecurityForm.powerAtt)" target="_blank">授权委托书(查看)</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.letComBidSec)" v-show="bidSecurityForm.letComBidSec !== undefined && bidSecurityForm.letComBidSec != ''" :href="isHttp(bidSecurityForm.letComBidSec)" target="_blank">投标保函承诺书（银行）查看</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.carder1)" v-show="bidSecurityForm.carder1 !== undefined && bidSecurityForm.carder1 != ''" :href="isHttp(bidSecurityForm.carder1)" target="_blank">授权人身份证正面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.carder2)" v-show="bidSecurityForm.carder2 !== undefined && bidSecurityForm.carder2 != ''" :href="isHttp(bidSecurityForm.carder2)" target="_blank">授权人身份证背面</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.tenderCom)" v-show="bidSecurityForm.tenderCom !== undefined && bidSecurityForm.tenderCom != ''" :href="isHttp(bidSecurityForm.tenderCom)" target="_blank">投标承诺书（担保公司)查看</el-link>
            </td>
          </tr>
          <tr>
            <th>其它信息:</th>
            <td :colspan="3">
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.payVoucher)" v-show="bidSecurityForm.payVoucher !== undefined && bidSecurityForm.payVoucher != ''" :href="isHttp(bidSecurityForm.payVoucher)" target="_blank">支付凭证</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.docUrl)" v-show="bidSecurityForm.docUrl !== undefined && bidSecurityForm.docUrl != ''" :href="isHttp(bidSecurityForm.docUrl)" target="_blank">下载保单</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.correctUrl)" v-show="bidSecurityForm.correctUrl !== undefined && bidSecurityForm.correctUrl != ''" :href="isHttp(bidSecurityForm.correctUrl)" target="_blank">下载批改保单</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.invUrl)" v-show="bidSecurityForm.invUrl !== undefined && bidSecurityForm.invUrl != ''" :href="isHttp(bidSecurityForm.invUrl)" target="_blank">下载发票</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.letterComm)" v-show="bidSecurityForm.letterComm !== undefined && bidSecurityForm.letterComm != ''" :href="isHttp(bidSecurityForm.letterComm)" target="_blank">承诺书(查看)</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.enterqualifi)" v-show="bidSecurityForm.enterqualifi !== undefined && bidSecurityForm.enterqualifi != ''" :href="isHttp(bidSecurityForm.enterqualifi)" target="_blank">资质证书1</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.enterQualifi2)" v-show="bidSecurityForm.enterQualifi2 !== undefined && bidSecurityForm.enterQualifi2 != ''" :href="isHttp(bidSecurityForm.enterQualifi2)" target="_blank">资质证书2</el-link>
              <el-link class="linkA" :underline='false' v-if="isContainUndefinedAnd(bidSecurityForm.enterQualifi3)" v-show="bidSecurityForm.enterQualifi3 !== undefined && bidSecurityForm.enterQualifi3 != ''" :href="isHttp(bidSecurityForm.enterQualifi3)" target="_blank">资质证书3</el-link>
            </td>
          </tr>
        </table>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormShowDanBaoVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 金函网二维码 -->
    <el-dialog title="支付信息" :visible.sync="jinhanwangVisible" width="1000px">
      <div>
        <table border="0" cellpadding="0" cellspacing="0" class="tablem">
          <tbody>
            <tr>
              <td colspan="4" align="left">
                <div class="weixins">
                  <div class="weixin"><img src="../../../static/img/weixin.png" alt=""></div>
                  <div class="weixintext">【重要提示】<br>1、请添加客服微信<br>2、<span class="redzi">打款后将转账凭证及时发给客服</span><br>3、支付问题、保函下载、发票均可咨询客服</div>
                </div>
              </td>
            </tr>
            <tr>
              <td align="left" width="15%">应付金额</td>
              <td align="left" class="dazi" width="30%"> {{ payform.imoney }}元</td>
              <td align="center" class="bluezi" width="10%" @click="copyText(payform.imoney)"> 复制</td>
              <td rowspan="4" align="left" style="font-size:20px;line-height:30px;">
                1、<span class="redzi">必须</span>基本户转账，一般户、个人卡转账无效，转错需退款<br>
                2、点击<span class="bluezi" @click="copyJHWAll()">【全部复制】</span>转发给财务
              </td>
            </tr>
            <tr>
              <td align="left">收款单位</td>
              <td align="left">内蒙古中工保担保有限公司</td>
              <td align="center" class="bluezi" @click="copyText('内蒙古中工保担保有限公司')">复制</td>
            </tr>
            <tr>
              <td align="left">收款账号</td>
              <td align="left">15050170661700000471</td>
              <td align="center" class="bluezi" @click="copyText('15050170661700000471')">复制</td>
            </tr>
            <tr>
              <td align="left">收款银行</td>
              <td align="left">中国建设银行股份有限公司呼和浩特乌兰察布东街园艺御景支行</td>
              <td align="center" class="bluezi" @click="copyText('中国建设银行股份有限公司呼和浩特乌兰察布东街园艺御景支行')">复制</td>
              <!-- <td align="center" class="bluezi">&nbsp;</td> -->
            </tr>
            <tr>
              <td align="left">转账备注</td>
              <td align="left">{{ payform.remark }}</td>
              <td align="center" class="bluezi" @click="copyText(payform.remark)">复制</td>
              <td align="left" class="redzi">转账必填，填错需退款重新申请</td>
            </tr>
            <tr>
              <td colspan="4" align="left" style="height:80px">【转账备注】<span class="redzi">为转账必填项，</span>输错需退款重新申请。不同银行名称不同，如“附言”、“用途”、“备注”、“摘要”等。
                <div class="yincangs">
                  <div class="yincangkuang"></div>
                  <textarea class="yincang" style="margin-top: 0px;width:0px;height:0px;border-style:solid;border-color:#fff;box-shadow:none" id="inputbox"></textarea>
                </div>
              </td>
            </tr>

          </tbody>
        </table>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="jinhanwangVisible = false">取 消</el-button>
        <el-button type="primary" @click="jinhanwangVisible = false" :loading="oloading">确 定</el-button>
      </div>
    </el-dialog>

    <!--金涵保二维码-->
    <el-dialog title="支付信息" :visible.sync="jinhanbaoVisible" width="1000px">
      <div>
        <table border="0" cellpadding="0" cellspacing="0" class="tablem">
          <tbody>
            <tr>
              <td colspan="4" align="left">
                <div class="weixins">
                  <div class="weixin"><img src="../../../static/img/weixin.png" alt=""></div>
                  <div class="weixintext">【重要提示】<br>1、请添加客服微信<br>2、<span class="redzi">打款后将转账凭证及时发给客服</span><br>3、支付问题、保函下载、发票均可咨询客服</div>
                </div>
              </td>
            </tr>
            <tr>
              <td align="left" width="15%">应付金额</td>
              <td align="left" class="dazi" width="30%"> {{payform.imoney}}元</td>
              <td align="center" class="bluezi" width="10%" @click="copyText(payform.imoney)"> 复制</td>
              <td rowspan="4" align="left" style="font-size:20px;line-height:30px;">
                <div v-if="payform.inCmpid==4 || payform.inCmpid==10">1、<span class="redzi">支持对公和其他转账方式</span></div>
                <div v-else>1、<span class="redzi">必须</span>基本户转账，一般户、个人卡转账无效，转错需退款</div>
                <br>
                2、点击<span class="bluezi" @click="copyJHBAll()">【全部复制】</span>转发给财务
              </td>
            </tr>
            <tr>
              <td align="left">收款单位</td>
              <td align="left">内蒙古金函保担保有限责任公司</td>
              <td align="center" class="bluezi"><span @click="copyText('内蒙古金函保担保有限责任公司')">复制</span></td>
            </tr>
            <tr>
              <td align="left">收款账号</td>
              <td align="left">152474787150</td>
              <td align="center" class="bluezi" @click="copyText('152474787150')">复制</td>
            </tr>
            <tr>
              <td align="left">收款银行</td>
              <td align="left">中国银行股份有限公司呼和浩特市巨海支行</td>
              <td align="center" class="bluezi" @click="copyText('中国银行股份有限公司呼和浩特市巨海支行')">复制</td>
              <!-- <td align="center" class="bluezi">&nbsp;</td> -->
            </tr>
            <tr>
              <td align="left">转账备注</td>
              <td align="left">{{payform.remark}}</td>
              <td align="center" class="bluezi" @click="copyText(payform.remark)">复制</td>
              <td align="left" class="redzi">转账必填，填错需退款重新申请</td>
            </tr>
            <tr>
              <td colspan="4" align="left" style="height:80px">【转账备注】<span class="redzi">为转账必填项，</span>输错需退款重新申请。不同银行名称不同，如“附言”、“用途”、“备注”、“摘要”等。
                <div class="yincangs">
                  <div class="yincangkuang"></div>
                  <textarea class="yincang" style="margin-top: 0px;width:0px;height:0px;border-style:solid;border-color:#fff;box-shadow:none" id="inputbox"></textarea>
                </div>
              </td>
            </tr>

          </tbody>
        </table>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="jinhanbaoVisible = false">取 消</el-button>
        <el-button type="primary" @click="jinhanbaoVisible = false" :loading="oloading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import auth from '@/utils/auth'
import utils from '@/utils/utils'
import _ from 'lodash'
import {
  GetInsure,
  deleteWindow,
  UpPayVoucher,
  giveUpInsure,
  GetInsureBidsecurityAll,
  ReturnBond,
  GetInsureInsureMigrantWorkers,
  GetInsureOne
} from '@/api/insure'
import { getChina } from '@/api/china'

export default {
  name: 'FaBu.vue',
  data() {
    return {
      canshu: {},
      msgk: 0,
      activeName: 'first',
      options: [],
      url: '',
      tableData: {
        list: [],
        total: 0
      },
      fileListletterComm: [],
      fileListceRepresentative: [],
      fileListpowerAtt: [],
      fileListletComBidSec: [],
      fileListtenderCom: [],
      fileListbidDocUrl: [],
      fileListletComBidSec: [],
      value1: [],
      bhtype: '',
      bidSecurityForm: {}, // 查看实体

      dialogFormShowVisible: false,
      dialogOtherFormShowVisible: false,
      cur_page: 1,
      dxnum: 0,
      multipleSelection: [],
      editVisible: false,
      createVisible: false,
      loading: false,
      oloading: false,
      jinhanwangVisible: false,
      jinhanbaoVisible:false,
      payform: {},
      isActive: '',
      provinces: [],
      citys: [],
      areas: [],
      search: {
        riqi: []
      },
      bindVisible: false,
      upform: {},
      upVisible: false,
      bindform: {
        uuid: '',
        plcApplyReason: ''
      },
      dialogFormShowDanBaoVisible: false,
      templook: {}
    }
  },
  computed: {
    uploadUrl: function() {
      return process.env.VUE_APP_BASE_API + '/UpLoadImageController/upLoadImage'
    }
  },
  filters: {
    parseTime: function(time, cFormat) {
      if (time !== null && time !== undefined) {
        if (arguments.length === 0) {
          return null
        }

        if (time.indexOf('T') !== -1) {
          time = time.replace('T', ' ')
        }

        var jia = time.indexOf('+')
        if (jia !== -1) {
          time = time.substring(0, jia)
        }

        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time)
          }
          if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
          }
          date = new Date(time)
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(
          /{(y|m|d|h|i|s|a)+}/g,
          (result, key) => {
            let value = formatObj[key]
            // Note: getDay() returns 0 on Sunday
            if (key === 'a') {
              return ['日', '一', '二', '三', '四', '五', '六'][value]
            }
            if (result.length > 0 && value < 10) {
              value = '0' + value
            }
            return value || 0
          }
        )
        return time_str
      } else {
        return ''
      }
    }
  },
  created() {
    if (this.msgk == 0) {
      this.canshu.itype = '4'
      this.getData()
    }
    this.getprovinces()
  },

  methods: {
    // 判断是否本系统oss文件地址
    isHttp(url) {
      if (url != undefined && url.indexOf('http') >= 0) {
        return url
      } else {
        return utils.getUrl() + url
      }
    },
    formatStatus(row, column, cellValue, index) {
      var state = ''
      switch (row.state) {
        case 1:
          state = '待审核'
          break
        case 2:
          state = '审核通过'
          break
        case 3:
          state = '待支付'
          break
        case 88:
          state = '退保中'
          break
        case 89:
          state = '退保成功'
          break
        case 99:
          state = '已完成'
          break
        case 0:
          state = '拒保'
          break
        case 77:
          state = '审核不通过'
          break
        case 4:
          state = '取消'
          break
        default:
          state = '删除'
          break
      }
      return state
    },
    formattype(row, column, cellValue, index) {
      var itype = ''
      switch (row.itype) {
        case 4:
          itype = '投标保证保函'
          break
        case 5:
          itype = '合同履约保证保函'
          break
        case 7:
          itype = '农民工工资支付保函'
          break
        case 6:
          itype = '工程款支付保证保函'
          break
        case 8:
          itype = '工程质量保证保函'
          break
        case 9:
          itype = '预付款保证保函'
          break
      }
      return itype
    },
    // -------------------------------------------------------------
    // 上传缴费凭证
    up(row) {
      this.upVisible = true
      this.upform = {
        uuid: row.uuid,
        bhtype: '3',
        payVoucher: ''
      }
    },
    // 订单管理--上传
    saveUp() {
      if (!this.upform.payVoucher) {
        this.$message('请上传缴费凭证')
        return false
      }
      auth.objSetToken(this.upform)
      UpPayVoucher(this.upform)
        .then(res => {
          if (res.code === 20000) {
            this.cur_page = 1
            this.getData()
            this.upVisible = false
          } else {
            this.$message(JSON.stringify(res.data.msg))
          }
        })
        .catch(res => {
          // this.$message("请与管理员联系");
        })
    },
    // 去付款--跳转预付款页面
    pay(row) {
      if (row.icompid == '99') {
        this.jinhanwangVisible = true
        this.payform = row
      } else if(row.icompid == '98'){
        this.jinhanbaoVisible = true
        this.payform = row
      } else {
        window.open(row.payUrl)
      }
    },
    // 去付款--审核成功
    sumbitWindow(row) {
      var url = process.env.VUE_APP_BASE_API + 'PayInsureController/InsureBond'
      var inform = { uuid: row.uuid }
      auth.objSetToken(inform)
      this.$axios
        .post(url, inform)
        .then(res => {
          if (res.code === 20000) {
            this.cur_page = 1
            this.getData()
            window.open(res.data)
          } else {
            this.$message(JSON.stringify(res.data.msg))
          }
        })
        .catch(res => {
          // this.$message("请与管理员联系");
        })
    },
    // -------------------------------------------------------------
    clearTable() {
      this.search = {
        mlname: '',
        state: '',
        hid: ''
      }
    },
    //页码
    indexMethod(index) {
      return (this.cur_page - 1) * 10 + index + 1
    },
    // 分页导航
    handleCurrentChange(val) {
      this.cur_page = val
      this.getData()
    },
    // 获取 easy-mock 的模拟数据
    getData() {
      var self = this
      self.loading = true
      var startTime = null
      var endTime = null
      if (self.search.riqi != null) {
        startTime = self.search.riqi[0]
        endTime = self.search.riqi[1]
      }
      GetInsure({
        //4投标保证保险
        page: self.cur_page,
        itype: this.canshu.itype,
        limit: 10,
        startTime: startTime,
        endTime: endTime,
        seachCode: self.search.seachCode,
        sessionToken: auth.getToken()
      })
        .then(res => {
          if (res.code === 20000) {
            self.tableData.list = res.data.list.records
            self.tableData.total = res.data.list.total
          } else {
            self.tableData.list = []
            self.tableData.total = 0
          }
        })
        .catch(res => {
          // this.$message("请与管理员联系");
        })
      self.loading = false
    },

    // 打开退保订单
    ReturnWindow(row) {
      this.bindform.uuid = row.uuid
      this.bindVisible = true
    },
    // 订单管理--退保
    saveBind() {
      if (
        this.bindform.plcApplyReason != undefined &&
        this.bindform.plcApplyReason != null &&
        this.bindform.plcApplyReason != ''
      ) {
        this.oloading = true
        //   var url = process.env.VUE_APP_BASE_API + 'PayInsureController/ReturnBond'
        var inform = _.cloneDeep(this.bindform)
        auth.objSetToken(inform)

        //   this.$axios
        //     .post(url, inform)
        ReturnBond(inform)
          .then(res => {
            this.oloading = false
            if (res.code === 20000) {
              this.cur_page = 1
              this.getData()
              this.bindVisible = false
            } else {
              this.$message(JSON.stringify(res.data.msg))
            }
          })
          .catch(res => {
            this.oloading = false
            // this.$message("请与管理员联系");
          })
      } else {
        this.$message('请填写退保原因')
      }
    },
    // 删除
    openDeleteWindow(row) {
      this.$confirm('要删除该条项目信息吗?', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          var inform = _.cloneDeep(row)
          auth.objSetToken(inform)
          deleteWindow(inform)
            .then(res => {
              if (res.code === 20000) {
                this.cur_page = 1
                this.getData()
              } else {
                this.$message(JSON.stringify(res.data.msg))
              }
            })
            .catch(res => {
              // this.$message("请与管理员联系");
            })
        })
        .catch(() => {})
    },
    // 下载保单
    DownWindow(row) {
      this.loading = true
      if (row.docUrl == null || row.docUrl == '') {
        var url = process.env.VUE_APP_BASE_API + '/PayInsureController/DownBond'
        var inform = { uuid: row.uuid }
        auth.objSetToken(inform)
        this.$axios
          .post(url, inform)
          .then(res => {
            if (res.code == 20000) {
              this.cur_page = 1
              this.getData()
              this.loading = false

              // window.location.href = utils.getUrl() + res.data
              if (res.data.indexOf('http') >= 0) {
                if (res.data.indexOf('.shtml') >= 0) {
                  window.open(res.data)
                } else {
                  window.open(
                    process.env.VUE_APP_BASE_API +
                      '/downloadFile/getDowByUrl?path=' +
                      res.data
                  )
                }
              } else {
                window.open(utils.getUrl() + res.data)
              }
            } else {
              this.$message('保单未生成，请联系系统管理员')
              this.loading = false
            }
          })
          .catch(res => {
            // this.$message("请与管理员联系");
          })
      } else {
        if (row.docUrl.indexOf('http') >= 0) {
          if (row.docUrl.indexOf('.shtml') >= 0) {
            window.open(url)
          } else {
            window.open(
              process.env.VUE_APP_BASE_API +
                '/downloadFile/getDowByUrl?path=' +
                row.docUrl
            )
          }
        } else {
          window.open(utils.getUrl() + row.docUrl)
        }
      }
    },
    // 下载发票
    fapiao(row) {
      if (row.invUrl != null && row.invUrl != '' && row.icompid != '4') {
        if (row.invUrl.indexOf('http') >= 0) {
          if (row.invUrl.indexOf('.shtml') >= 0) {
            window.open(url)
          } else {
            window.open(
              process.env.VUE_APP_BASE_API +
                '/downloadFile/getDowByUrl?path=' +
                row.invUrl
            )
          }
        } else {
          window.open(utils.getUrl() + row.invUrl)
        }
      } else {
        var url =
          process.env.VUE_APP_BASE_API + '/PayInsureController/InvoiceBond'
        var inform = { uuid: row.uuid }
        auth.objSetToken(inform)
        this.$axios
          .post(url, inform)
          .then(res => {
            if (res.code == 20000) {
              if (row.invUrl.indexOf('http') >= 0) {
                window.open(row.invUrl)
              } else {
                window.open(utils.getUrl() + row.invUrl)
              }
            } else {
              this.$message('发票未生成，请联系系统管理员')
              this.loading = false
            }
          })
          .catch(res => {
            // this.$message("请与管理员联系");
          })
      }
      this.cur_page = 1
      this.getData()
      this.loading = false
    },
    //查询
    query() {
      this.cur_page = 1
      this.getData()
    },
    exportExcel() {
      this.$confirm('确定要导出当前数据？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.getExpportData()
        })
        .catch(() => {})
    }, // 导出数据
    getExpportData: function() {
      var self = this

      //--导出过程中等待动作
      const loading = this.$loading({
        lock: true,
        text: '正在导出，请稍等......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      //--页面查询条件
      var startTime = null
      var endTime = null
      if (self.search.riqi != null) {
        startTime = self.search.riqi[0]
        endTime = self.search.riqi[1]
      }
      var obj = {
        bitype: 0,
        startTime: startTime,
        endTime: endTime,
        seachcode: self.search.seachcode,
        sessionToken: auth.getToken()
      }
      //   this.url = process.env.VUE_APP_BASE_API + 'InsureController/GetVInsures'
      this.url =
        process.env.VUE_APP_BASE_API +
        '/insure-bidsecurity/GetVInsuresBidsecurity'
      this.$axios
        .post(this.url, obj)
        .then(
          res => {
            //--查询完成
            if (res.data.length > 0) {
              require.ensure([], () => {
                const {
                  export_json_to_excel
                } = require('static/js/Export2Excel')
                const tHeader = [
                  '序号',
                  '订单号',
                  '投保企业',
                  '提交时间',
                  '项目名称',
                  '保函类型',
                  '支付类型',
                  '保险公司名称',
                  '保 费',
                  '保证金金额',
                  '状 态'
                ]
                const filterVal = [
                  'index',
                  'orderno',
                  'bcmpname',
                  'addtime',
                  'itemname',
                  'itypename',
                  'bhtypename',
                  'icmpName',
                  'imoney',
                  'bail',
                  'statename'
                ]
                var templist = res.data
                var i = 1
                templist.forEach(element => {
                  element.index = i++
                })
                const data = self.formatJson(filterVal, templist)
                export_json_to_excel(tHeader, data, '订单信息')
              })
            } else if (res.code == 20000 && res.data.length == 0) {
              this.$message({
                message: '暂无可导出的数据',
                duration: 2000,
                type: 'warning'
              })
            } else {
              this.$message({
                message: '数据出錯，请联系管理员',
                duration: 2000,
                type: 'warning'
              })
            }
            //关闭等待
            loading.close()
          },
          error => {
            //关闭等待
            this.$message({
              message: '数据出錯，请联系管理员',
              duration: 2000,
              type: 'warning'
            })
            loading.close()
          }
        )
        .catch(res => {
          //关闭等待
          this.$message('请与管理员联系')
          loading.close()
        })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    sub(row) {
      switch (row.itype) {
        case 4:
          auth.setuuid(row.uuid)
          this.$router.push('/bidSecurity')

          break
        case 5:
          auth.setuuid(row.uuid)
          this.$router.push('/contractPerformance')

          break
        case 6:
          auth.setuuid(row.uuid)
          this.$router.push('/projectPayment')

          break
        case 7:
          auth.setuuid(row.uuid)
          this.$router.push('/migrantWorkers')
          break
        case 8:
          auth.setuuid(row.uuid)
          this.$router.push('/constructionQuality')
          break
      }
    },
    // 打开查看对话框
    handleCheck(row) {
      if (row.itype == '4') {
        // 3 担保保函
        this.dialogFormShowDanBaoVisible = true
        this.bhtype = row.bhtype
        var self = this
        GetInsureBidsecurityAll({
          uuid: row.uuid
        }).then(res => {
          if (res.code == 20000) {
            var data = res.data.item
            self.bidSecurityForm = res.data.item
            self.bidSecurityForm.endTime = row.endTime // 保证金缴纳截止时间
            this.bidSecurityForm.province = this.bidSecurityForm.province.toString()
            if (this.bidSecurityForm.city) {
              this.bidSecurityForm.city = this.bidSecurityForm.city.toString()
            }
            if (this.bidSecurityForm.area) {
              this.bidSecurityForm.area = this.bidSecurityForm.area.toString()
            }
            if (
              self.bidSecurityForm.insurelineman == null ||
              self.bidSecurityForm.insurelineman == '' ||
              self.bidSecurityForm.insurelineman == 'undefined'
            ) {
              self.bidSecurityForm.insurelineman = self.bidSecurityForm.linman
            }
            if (
              self.bidSecurityForm.insurelinephone == null ||
              self.bidSecurityForm.insurelinephone == '' ||
              self.bidSecurityForm.insurelinephone == 'undefined'
            ) {
              self.bidSecurityForm.insurelinephone =
                self.bidSecurityForm.linephone
            }
            self.bidSecurityForm.demo =
              utils.getUrl() + '资料真实性承诺书-投标保证保险模板.docx'
            self.value1.push(data.istartdate)
            self.value1.push(data.ienddate)
            self.bidSecurityForm.buslic =
              self.bidSecurityForm.buslic != null
                ? utils.getUrl() + self.bidSecurityForm.buslic
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.bidSecurityForm.cardimg1 =
              self.bidSecurityForm.cardimg1 != null
                ? utils.getUrl() + self.bidSecurityForm.cardimg1
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.bidSecurityForm.cardimg2 =
              self.bidSecurityForm.cardimg2 != null
                ? utils.getUrl() + self.bidSecurityForm.cardimg2
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.bidSecurityForm.openlicup =
              self.bidSecurityForm.openlicup != null
                ? utils.getUrl() + self.bidSecurityForm.openlicup
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.bidSecurityForm.enterQualifi2 =
              self.bidSecurityForm.enterQualifi2 != null &&
              self.bidSecurityForm.enterQualifi2 != ''
                ? utils.getUrl() + self.bidSecurityForm.enterQualifi2
                : utils.getUrl() + '无资料请上传本图.jpg'
            if (self.bidSecurityForm.payVoucher) {
              self.bidSecurityForm.payVoucher =
                utils.getUrl() + self.bidSecurityForm.payVoucher
            }
            if (
              self.bidSecurityForm.powerAtt == null ||
              self.bidSecurityForm.powerAtt == ''
            ) {
              self.bidSecurityForm.powerAtt = '授权委托书.doc'
            }
            self.fileListpowerAtt = [
              {
                name: self.bidSecurityForm.powerAtt,
                url: utils.getUrl() + self.bidSecurityForm.powerAtt
              }
            ]
            self.bidSecurityForm.powerAtt =
              utils.getUrl() + self.bidSecurityForm.powerAtt
            self.bidSecurityForm.enterqualifi =
              self.bidSecurityForm.enterqualifi != null &&
              self.bidSecurityForm.enterqualifi != ''
                ? utils.getUrl() + self.bidSecurityForm.enterqualifi
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.bidSecurityForm.enterQualifi3 =
              self.bidSecurityForm.enterQualifi3 != null &&
              self.bidSecurityForm.enterQualifi3 != ''
                ? utils.getUrl() + self.bidSecurityForm.enterQualifi3
                : utils.getUrl() + '无资料请上传本图.jpg'
            if (
              self.bidSecurityForm.letterComm == null ||
              self.bidSecurityForm.letterComm == ''
            ) {
              self.bidSecurityForm.letterComm =
                '资料真实性承诺书-投标保证保险模板.docx'
            }
            self.fileListletterComm = [
              {
                name: self.bidSecurityForm.letterComm,
                url: utils.getUrl() + self.bidSecurityForm.letterComm
              }
            ]
            self.bidSecurityForm.letterComm =
              utils.getUrl() + self.bidSecurityForm.letterComm
            self.bidSecurityForm.ceRepresentativedemo =
              utils.getUrl() + '法定代表人证明书.doc'
            self.bidSecurityForm.letComBidSecdemo =
              utils.getUrl() + '投标保函承诺书.doc'
            if (
              self.bidSecurityForm.ceRepresentative == null ||
              self.bidSecurityForm.ceRepresentative == ''
            ) {
              self.bidSecurityForm.ceRepresentative = '法定代表人证明书.doc'
            }
            self.bidSecurityForm.powerAttdemo =
              utils.getUrl() + '授权委托书.doc'
            self.fileListceRepresentative = [
              {
                name: self.bidSecurityForm.ceRepresentative,
                url: utils.getUrl() + self.bidSecurityForm.ceRepresentative
              }
            ]
            self.bidSecurityForm.ceRepresentative =
              utils.getUrl() + self.bidSecurityForm.ceRepresentative
            if (
              self.bidSecurityForm.bidDocUrl != null &&
              self.bidSecurityForm.bidDocUrl != ''
            ) {
              self.fileListbidDocUrl = [
                {
                  name: self.bidSecurityForm.bidDocUrl,
                  url: utils.getUrl() + self.bidSecurityForm.bidDocUrl
                }
              ]
              self.bidSecurityForm.bidDocUrl =
                utils.getUrl() + self.bidSecurityForm.bidDocUrl
            }
            self.bidSecurityForm.carder1 =
              self.bidSecurityForm.carder1 != null &&
              self.bidSecurityForm.carder1 != ''
                ? utils.getUrl() + self.bidSecurityForm.carder1
                : utils.getUrl() + '无资料请上传本图.jpg'

            if (
              self.bidSecurityForm.letComBidSec == null ||
              self.bidSecurityForm.letComBidSec == ''
            ) {
              self.bidSecurityForm.letComBidSec = '投标保函承诺书.doc'
            }
            self.fileListletComBidSec = [
              {
                name: self.bidSecurityForm.letComBidSec,
                url: utils.getUrl() + self.bidSecurityForm.letComBidSec
              }
            ]
            self.bidSecurityForm.letComBidSec =
              utils.getUrl() + self.bidSecurityForm.letComBidSec
            self.bidSecurityForm.tenderComdemo =
              utils.getUrl() + '投标承诺书.doc'
            self.bidSecurityForm.carder2 =
              self.bidSecurityForm.carder2 != null &&
              self.bidSecurityForm.carder2 != ''
                ? utils.getUrl() + self.bidSecurityForm.carder2
                : utils.getUrl() + '无资料请上传本图.jpg'
            if (
              self.bidSecurityForm.tenderCom == null ||
              self.bidSecurityForm.tenderCom == ''
            ) {
              self.bidSecurityForm.tenderCom = '投标承诺书.doc'
            }
            self.fileListtenderCom = [
              {
                name: self.bidSecurityForm.tenderCom,
                url: utils.getUrl() + self.bidSecurityForm.tenderCom
              }
            ]
            self.bidSecurityForm.tenderCom =
              utils.getUrl() + self.bidSecurityForm.tenderCom

            this.provinces.forEach(e => {
              if (e.uuid == this.bidSecurityForm.province) {
                this.bidSecurityForm.provinceName = e.name
              }
            })

            if (self.bidSecurityForm.province != null) {
              self.getcitys(self.bidSecurityForm.province, 3)
            }
            if (self.bidSecurityForm.city != null) {
              self.getareas(self.bidSecurityForm.city, 3)
            }
          } else {
            this.$message(JSON.stringify(res.msg))
          }
        })
      } else if (row.itype == '7') {
        this.dialogFormShowVisible = true
        GetInsureInsureMigrantWorkers({
          sessionToken: auth.getToken(),
          uuid: row.uuid
        }).then(res => {
          if (res.code == 20000 || res.code == 1) {
            let self = this
            var data = res.data.item
            // -- 开始赋值 -----------------------------------------
            self.templook = this.initGetDataNm(data)
            self.templook.uuid = this.uuid

            switch (this.templook.nmgDept) {
              case 1:
                this.templook.nmgDeptName = '住建'
                break
              case 2:
                this.templook.nmgDeptName = '水利'
                break
              case 3:
                this.templook.nmgDeptName = '交通'
                break
              case 4:
                this.templook.nmgDeptName = '电力'
                break
              case 5:
                this.templook.nmgDeptName = '铁路'
                break
              case 6:
                this.templook.nmgDeptName = '民航'
                break
              case 7:
                this.templook.nmgDeptName = '农牧'
                break
              case 8:
                this.templook.nmgDeptName = '能源'
                break
            }
            if (this.templook.qualificationType1) {
              switch (this.templook.qualificationType1) {
                case 1:
                  this.templook.qualificationType1Name = '工程项目总承包企业'
                  break
                case 2:
                  this.templook.qualificationType1Name = '施工总承包企业'
                  break
                case 3:
                  this.templook.qualificationType1Name = '专业承包企业'
                  break
                case 4:
                  this.templook.qualificationType1Name = '施工劳务企业'
                  break
              }
            }
            if (this.templook.qualificationType) {
              switch (this.templook.qualificationType) {
                case 1:
                  this.templook.qualificationTypeName = '特级'
                  break
                case 2:
                  this.templook.qualificationTypeName = '一级'
                  break
                case 3:
                  this.templook.qualificationTypeName = '二级'
                  break
                case 4:
                  this.templook.qualificationTypeName = '三级'
                  break
                case 5:
                  this.templook.qualificationTypeName = '专业承包'
                  break
              }
            }
            self.templook.bhtype = '1'

            self.templook.demo =
              utils.getUrl() +
              '资料真实性承诺书-农民工工资支付保证保险模板.docx'

            self.templook.demo =
              utils.getUrl() +
              '资料真实性承诺书-农民工工资支付保证保险模板.docx'
            //   self.templook.uuid = self.$route.query.uuid
            if (self.templook.qualificationType != null)
              self.templook.qualificationType = self.templook.qualificationType.toString()
            if (data.istartdate != null) self.value1.push(data.istartdate)
            if (data.ienddate != null) self.value1.push(data.ienddate)
            self.templook.buslic =
              self.templook.buslic != null && self.templook.buslic != ''
                ? utils.getUrl() + self.templook.buslic
                : ''
            self.templook.cardimg1 =
              self.templook.cardimg1 != null && self.templook.cardimg1 != ''
                ? utils.getUrl() + self.templook.cardimg1
                : ''
            self.templook.cardimg2 =
              self.templook.cardimg2 != null && self.templook.cardimg2 != ''
                ? utils.getUrl() + self.templook.cardimg2
                : ''
            self.templook.openlicup =
              self.templook.openlicup != null && self.templook.openlicup != ''
                ? utils.getUrl() + self.templook.openlicup
                : ''
            self.templook.enterQualifi2 =
              self.templook.enterQualifi2 != null &&
              self.templook.enterQualifi2 != ''
                ? utils.getUrl() + self.templook.enterQualifi2
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.templook.enterqualifi =
              self.templook.enterqualifi != null &&
              self.templook.enterqualifi != ''
                ? utils.getUrl() + self.templook.enterqualifi
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.templook.enterQualifi3 =
              self.templook.enterQualifi3 != null &&
              self.templook.enterQualifi3 != ''
                ? utils.getUrl() + self.templook.enterQualifi3
                : utils.getUrl() + '无资料请上传本图.jpg'

            self.templook.prodCertificate =
              self.templook.prodCertificate != null &&
              self.templook.prodCertificate != ''
                ? utils.getUrl() + self.templook.prodCertificate
                : utils.getUrl() + '无资料请上传本图.jpg'

            self.templook.ttype = '1'

            self.templook.counterguarant = '1'

            if (self.templook.province != null)
              self.getcitys(self.templook.province, 2)
            if (self.templook.city != null) self.getareas(self.templook.city, 2)

            if (
              self.templook.guaranagree == null ||
              self.templook.guaranagree == '' ||
              self.templook.guaranagree == undefined
            )
              self.templook.guaranagree = '无资料请上传本图.jpg'
            self.fileListguaranagree = [
              {
                name: self.templook.guaranagree,
                url: utils.getUrl() + self.templook.guaranagree
              }
            ]
            self.templook.guaranagree =
              utils.getUrl() + self.templook.guaranagree

            if (
              self.templook.entercreditrepor == null ||
              self.templook.entercreditrepor == '' ||
              self.templook.entercreditrepor == undefined
            )
              self.templook.entercreditrepor = '无资料请上传本图.jpg'
            self.fileListentercreditrepor = [
              {
                name: self.templook.entercreditrepor,
                url: utils.getUrl() + self.templook.entercreditrepor
              }
            ]
            self.templook.entercreditrepor =
              utils.getUrl() + self.templook.entercreditrepor

            if (
              self.templook.auditreport == null ||
              self.templook.auditreport == '' ||
              self.templook.auditreport == undefined
            ) {
              // self.migrantWorkersForm.auditreport = '无资料请上传本图.jpg'
            } else {
              self.fileListtauditreport = [
                {
                  name: self.templook.auditreport,
                  url: utils.getUrl() + self.templook.auditreport
                }
              ]
            }
            this.provinces.forEach(e => {
              if (e.uuid == this.templook.province) {
                this.templook.provinceName = e.name
              }
            })
            if (self.templook.province != null) {
              self.getcitys(self.templook.province, 3)
            }
            if (self.templook.city != null) {
              self.getareas(self.templook.city, 3)
            }
            self.templook.auditreport =
              utils.getUrl() + self.templook.auditreport

            if (
              self.templook.taxpaycertificate == null ||
              self.templook.guaranagree == '' ||
              self.templook.guaranagree == undefined
            ) {
              // self.migrantWorkersForm.taxpaycertificate = '无资料请上传本图.jpg'
            } else {
              self.fileListtaxpaycertificate = [
                {
                  name: self.templook.taxpaycertificate,
                  url: utils.getUrl() + self.templook.taxpaycertificate
                }
              ]
            }

            self.templook.taxpaycertificate =
              utils.getUrl() + self.templook.taxpaycertificate

            if (
              self.templook.finanreport == null ||
              self.templook.finanreport == '' ||
              self.templook.finanreport == undefined
            ) {
              self.templook.finanreport = '无资料请上传本图.jpg'
            } else {
              self.fileListfinanreport = [
                {
                  name: self.templook.finanreport,
                  url: utils.getUrl() + self.templook.finanreport
                }
              ]
            }

            self.templook.finanreport =
              utils.getUrl() + self.templook.finanreport

            if (
              self.templook.enginperformance == null ||
              self.templook.enginperformance == '' ||
              self.templook.enginperformance == undefined
            ) {
              // self.migrantWorkersForm.enginperformance = '无资料请上传本图.jpg'
            } else {
              self.fileListenginperformance = [
                {
                  name: self.templook.enginperformance,
                  url: utils.getUrl() + self.templook.enginperformance
                }
              ]
            }

            self.templook.enginperformance =
              utils.getUrl() + self.templook.enginperformance

            if (
              self.templook.bidnotice == null ||
              self.templook.bidnotice == '' ||
              self.templook.bidnotice == undefined
            ) {
              //  self.migrantWorkersForm.bidnotice = '无资料请上传本图.jpg'
            } else {
              self.fileListbidnotice = [
                {
                  name: self.templook.bidnotice,
                  url: utils.getUrl() + self.templook.bidnotice
                }
              ]
            }

            self.templook.bidnotice = utils.getUrl() + self.templook.bidnotice

            if (
              self.templook.recordProof == null ||
              self.templook.recordProof == '' ||
              self.templook.recordProof == undefined
            ) {
              // self.migrantWorkersForm.recordProof = '无资料请上传本图.jpg'
            } else {
              self.fileListrecordProof = [
                {
                  name: self.templook.recordProof,
                  url: utils.getUrl() + self.templook.recordProof
                }
              ]
            }

            self.templook.recordProof =
              utils.getUrl() + self.templook.recordProof

            //---------------其他资料-----------------------

            if (
              self.templook.otherInformation == null ||
              self.templook.otherInformation == '' ||
              self.templook.otherInformation == undefined
            ) {
              // self.migrantWorkersForm.otherInformation = '无资料请上传本图.jpg'
            } else {
              self.fileListrecordOther = [
                {
                  name: self.templook.otherInformation,
                  url: utils.getUrl() + self.templook.otherInformation
                }
              ]
            }

            self.templook.otherInformation =
              utils.getUrl() + self.templook.otherInformation

            //--------------------------------------

            if (
              self.templook.rosterPdf == null ||
              self.templook.rosterPdf == '' ||
              self.templook.rosterPdf == undefined
            )
              self.templook.rosterPdf = '无资料请上传本图.jpg'
            self.fileListrosterPdf = [
              {
                name: self.templook.rosterPdf,
                url: utils.getUrl() + self.templook.rosterPdf
              }
            ]
            self.templook.rosterPdf = utils.getUrl() + self.templook.rosterPdf

            if (
              self.templook.letterComm == null ||
              self.templook.letterComm == '' ||
              self.templook.letterComm == undefined
            )
              self.templook.letterComm =
                '资料真实性承诺书-农民工工资支付保证保险模板.docx'
            self.fileListletterComm = [
              {
                name: self.templook.letterComm,
                url: utils.getUrl() + self.templook.letterComm
              }
            ]

            self.templook.letterComm = utils.getUrl() + self.templook.letterComm

            self.templook.summoney = self.templook.summoney / 10000
            self.getDx(self.templook.summoney)
          } else {
            this.$message(JSON.stringify(res.data.msg))
          }
        })
      } else {
        this.dialogOtherFormShowVisible = true
        GetInsureOne({
          uuid: row.uuid,
          itype: row.itype,
          sessionToken: auth.getToken()
        }).then(res => {
          let res1 = res
          let code = ''
          if (res1.code == 20000) {
            let self = this
            var data = res1.data.item
            self.templook = this.initGetData(data)

            if (this.templook.province) {
              this.templook.province = this.templook.province.toString()
            }
            if (this.templook.city) {
              this.templook.city = this.templook.city.toString()
            }
            if (this.templook.area) {
              this.templook.area = this.templook.area.toString()
            }
            self.templook.demo =
              utils.getUrl() + '资料真实性承诺书-合同履约保证保险模板.docx'
            self.templook.uuid = this.uuid
            //   }
            self.templook.doccode = utils.GettimeStamp(new Date())
            self.templook.bhtype = '1'
            //   self.tableData = data.stCastingsectionList
            if (data.istartdate != null) {
              self.value1.push(data.istartdate)
            }
            if (data.ienddate != null) self.value1.push(data.ienddate)
            self.templook.buslic =
              self.templook.buslic != null
                ? utils.getUrl() + self.templook.buslic
                : ''
            // console.log(self.templook.buslic, 212)
            self.templook.cardimg1 =
              self.templook.cardimg1 != null
                ? utils.getUrl() + self.templook.cardimg1
                : ''
            self.templook.cardimg2 =
              self.templook.cardimg2 != null
                ? utils.getUrl() + self.templook.cardimg2
                : ''
            self.templook.openlicup =
              self.templook.openlicup != null
                ? utils.getUrl() + self.templook.openlicup
                : ''

            self.templook.enterQualifi2 =
              self.templook.enterQualifi2 != null &&
              self.templook.enterQualifi2 != ''
                ? utils.getUrl() + self.templook.enterQualifi2
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.templook.enterqualifi =
              self.templook.enterqualifi != null &&
              self.templook.enterqualifi != ''
                ? utils.getUrl() + self.templook.enterqualifi
                : utils.getUrl() + '无资料请上传本图.jpg'
            self.templook.enterQualifi3 =
              self.templook.enterQualifi3 != null &&
              self.templook.enterQualifi3 != ''
                ? utils.getUrl() + self.templook.enterQualifi3
                : utils.getUrl() + '无资料请上传本图.jpg'
            //   self.contractPerformanceForm.intype = '1'
            this.provinces.forEach(e => {
              if (e.uuid == this.templook.province) {
                this.templook.provinceName = e.name
              }
            })
            if (self.templook.province != null) {
              self.getcitys(self.templook.province, 3)
            }
            if (self.templook.city != null) {
              self.getareas(self.templook.city, 3)
            }

            if (
              self.templook.guaranagree == null ||
              self.templook.guaranagree == '' ||
              self.templook.guaranagree == undefined
            ) {
              // self.contractPerformanceForm.guaranagree = '无资料请上传本图.jpg'
            } else {
              self.fileListguaranagree = [
                {
                  name: self.templook.guaranagree,
                  url: utils.getUrl() + self.templook.guaranagree
                }
              ]
            }

            self.templook.guaranagree =
              utils.getUrl() + self.templook.guaranagree

            if (
              self.templook.entercreditrepor == null ||
              self.templook.entercreditrepor == '' ||
              self.templook.entercreditrepor == undefined
            ) {
              // self.contractPerformanceForm.entercreditrepor =
              // '无资料请上传本图.jpg'
            } else {
              self.fileListentercreditrepor = [
                {
                  name: self.templook.entercreditrepor,
                  url: utils.getUrl() + self.templook.entercreditrepor
                }
              ]
            }

            self.templook.entercreditrepor =
              utils.getUrl() + self.templook.entercreditrepor

            if (
              self.templook.auditreport == null ||
              self.templook.auditreport == '' ||
              self.templook.auditreport == undefined
            ) {
              // self.contractPerformanceForm.auditreport = '无资料请上传本图.jpg'
            } else {
              self.fileListtauditreport = [
                {
                  name: self.templook.auditreport,
                  url: utils.getUrl() + self.templook.auditreport
                }
              ]
            }

            self.templook.auditreport =
              utils.getUrl() + self.templook.auditreport

            if (
              self.templook.taxpaycertificate == null ||
              self.templook.taxpaycertificate == '' ||
              self.templook.taxpaycertificate == undefined
            ) {
              // self.templook.taxpaycertificate =
              // '无资料请上传本图.jpg'
            } else {
              self.fileListtaxpaycertificate = [
                {
                  name: self.templook.taxpaycertificate,
                  url: utils.getUrl() + self.templook.taxpaycertificate
                }
              ]
            }

            self.templook.taxpaycertificate =
              utils.getUrl() + self.templook.taxpaycertificate

            if (
              self.templook.finanreport == null ||
              self.templook.finanreport == '' ||
              self.templook.finanreport == undefined
            ) {
              self.templook.finanreport = '无资料请上传本图.jpg'
            } else {
              self.fileListfinanreport = [
                {
                  name: self.templook.finanreport,
                  url: utils.getUrl() + self.templook.finanreport
                }
              ]
            }

            self.templook.finanreport =
              utils.getUrl() + self.templook.finanreport

            if (
              self.templook.enginperformance == null ||
              self.templook.enginperformance == '' ||
              self.templook.enginperformance == undefined
            ) {
              //  self.contractPerformanceForm.enginperformance =
              // '无资料请上传本图.jpg'
            } else {
              self.templook.enginperformance = [
                {
                  name: self.templook.enginperformance,
                  url: utils.getUrl() + self.templook.enginperformance
                }
              ]
            }

            self.templook.enginperformance =
              utils.getUrl() + self.templook.enginperformance

            if (
              self.templook.bidnotice == null ||
              self.templook.bidnotice == '' ||
              self.templook.bidnotice == undefined
            ) {
              // self.contractPerformanceForm.bidnotice = '无资料请上传本图.jpg'
            } else {
              self.fileListbidnotice = [
                {
                  name: self.templook.bidnotice,
                  url: utils.getUrl() + self.templook.bidnotice
                }
              ]
            }

            self.templook.bidnotice = utils.getUrl() + self.templook.bidnotice

            if (
              self.templook.recordProof == null ||
              self.templook.recordProof == '' ||
              self.templook.recordProof == undefined
            ) {
              // self.contractPerformanceForm.recordProof = '无资料请上传本图.jpg'
            } else {
              self.fileListrecordProof = [
                {
                  name: self.templook.recordProof,
                  url: utils.getUrl() + self.templook.recordProof
                }
              ]
            }

            self.templook.recordProof =
              utils.getUrl() + self.templook.recordProof

            if (
              self.templook.rosterPdf == null ||
              self.templook.rosterPdf == '' ||
              self.templook.rosterPdf == undefined
            ) {
              // self.contractPerformanceForm.rosterPdf = '无资料请上传本图.jpg'
            } else {
              self.fileListrosterPdf = [
                {
                  name: self.templook.rosterPdf,
                  url: utils.getUrl() + self.templook.rosterPdf
                }
              ]
            }

            self.templook.rosterPdf = utils.getUrl() + self.templook.rosterPdf

            if (
              self.templook.prolicense == null ||
              self.templook.prolicense == '' ||
              self.templook.prolicense == undefined
            ) {
              //   self.contractPerformanceForm.prolicense = '无资料请上传本图.jpg'
            } else {
              self.fileListprolicense = [
                {
                  name: self.templook.prolicense,
                  url: utils.getUrl() + self.templook.prolicense
                }
              ]
            }

            self.templook.prolicense = utils.getUrl() + self.templook.prolicense

            if (
              self.templook.letterComm == null ||
              self.templook.letterComm == '' ||
              self.templook.letterComm == undefined
            )
              self.templook.letterComm =
                '资料真实性承诺书-合同履约保证保险模板.docx'
            self.fileListletterComm = [
              {
                name: self.templook.letterComm,
                url: utils.getUrl() + self.templook.letterComm
              }
            ]
            self.templook.letterComm = utils.getUrl() + self.templook.letterComm
            self.getDx(self.templook.summoney)
            // console.log('其他保险查看运行成功')
          } else {
            this.$message(JSON.stringify(res1.msg))
          }
        })
      }
    },
    getDx(n) {
      this.dxnum = utils.number_chinese(n * 10000)
    },
    getprovinces() {
      var self = this
      getChina({ pid: 0 })
        .then(res => {
          self.provinces = res.data
        })
        .catch(res => {})
    },
    getcitys(province, id) {
      var self = this
      //   self.url = process.env.VUE_APP_BASE_API + 'ChinaController/getChina'
      //   self.$axios
      //     .post(self.url, {
      //       sessionToken: auth.getToken(),
      //       pid: province,
      //     })
      getChina({ pid: province })
        .then(res => {
          self.citys = res.data
          if (id == 1) {
            self.search.city = ''
            self.search.area = ''
            this.areas = []
          } else if (id == 3) {
            this.citys.forEach(e => {
              if (e.uuid == this.bidSecurityForm.city) {
                this.bidSecurityForm.cityName = e.name
                this.$forceUpdate()
              }
            })
          }
        })
        .catch(res => {})
    },

    getareas(city, id) {
      var self = this
      //   self.url = process.env.VUE_APP_BASE_API + 'ChinaController/getChina'
      //   self.$axios
      //     .post(self.url, {
      //       sessionToken: auth.getToken(),
      //       pid: city,
      //     })
      getChina({ pid: city })
        .then(res => {
          self.areas = res.data
          if (id == 1) {
            self.search.area = ''
          } else if (id == 3) {
            this.areas.forEach(e => {
              if (this.bidSecurityForm.area == e.uuid) {
                this.bidSecurityForm.areaName = e.name
                this.$forceUpdate()
              }
            })
          }
        })
        .catch(res => {})
    },
    handleAvatarSuccess(res, file) {
      this.upform.payVoucher = utils.getUrl() + res.data
    },
    initGetData(data) {
      if (data.doccode === undefined) {
        data.doccode = ''
      }
      if (data.itemname === undefined) {
        data.itemname = ''
      }
      if (data.summoney === undefined) {
        data.summoney = ''
      }
      if (data.firstCmpName === undefined) {
        data.firstCmpName = ''
      }
      if (data.firstBuslicno === undefined) {
        data.firstBuslicno = ''
      }
      if (data.cmpname === undefined) {
        data.cmpname = ''
      }
      if (data.buslicno === undefined) {
        data.buslicno = ''
      }

      if (data.bhtype === undefined) {
        data.bhtype = '1'
      }

      if (data.intype === undefined) {
        data.intype = '1'
      }

      if (data.cmpname === undefined) {
        data.cmpname = ''
      }
      if (data.buslicno === undefined) {
        data.buslicno = ''
      }
      if (data.adress === undefined) {
        data.adress = ''
      }
      if (data.bankinfo === undefined) {
        data.bankinfo = ''
      }
      if (data.pubaccout === undefined) {
        data.pubaccout = ''
      }
      if (data.linman === undefined) {
        data.linman = ''
      }
      if (data.mailadd === undefined) {
        data.mailadd = ''
      }

      if (data.invmailadd === undefined) {
        data.invmailadd = ''
      }
      if (data.icompid === undefined) {
        data.icompid = ''
      }
      return data
    },
    initGetDataNm(data) {
      // -- 处理undefined 数据
      if (data.doccode === undefined) {
        data.doccode = ''
      }
      if (data.itemname === undefined) {
        data.itemname = ''
      }
      if (data.commendate === undefined) {
        data.commendate = ''
      }
      if (data.completiondata === undefined) {
        data.completiondata = ''
      }
      if (data.nmgMean === undefined) {
        data.nmgMean = 2
      }
      if (data.summoney === undefined) {
        data.summoney = 0
      }

      if (data.accountNum === undefined) {
        data.accountNum = ''
      }
      if (data.bankName === undefined) {
        data.bankName = ''
      }
      if (data.buslic === undefined) {
        data.buslic = ''
      }
      if (data.cardimg2 === undefined) {
        data.cardimg2 = ''
      }
      if (data.cardimg1 === undefined) {
        data.cardimg1 = ''
      }
      if (data.openlicup === undefined) {
        data.openlicup = ''
      }
      if (data.prodCertificate === undefined) {
        data.prodCertificate = ''
      }
      if (data.enterqualifi === undefined) {
        data.enterqualifi = ''
      }

      if (data.enterQualifi2 === undefined) {
        data.enterQualifi2 = ''
      }

      if (data.enterQualifi3 === undefined) {
        data.enterQualifi3 = ''
      }

      if (data.taxpaycertificate === undefined) {
        data.taxpaycertificate = null
      }

      if (data.bidnotice === undefined) {
        data.bidnotice = null
      }

      if (data.auditreport === undefined) {
        data.auditreport = null
      }

      if (data.enginperformance === undefined) {
        data.enginperformance = null
      }

      if (data.recordProof === undefined) {
        data.recordProof = null
      }
      if (data.otherInformation === undefined) {
        data.otherInformation = null
      }
      if (data.bhtype === undefined) {
        data.bhtype = '1'
      }
      if (data.nmgDept === undefined) {
        data.nmgDept = 1
      }
      if (data.intype === undefined) {
        data.intype = '1'
      }
      if (data.ttype === undefined) {
        data.ttype = '1'
      }
      if (data.counterguarant === undefined) {
        data.counterguarant = '1'
      }
      if (data.icompid === undefined) {
        data.icompid = ''
      }
      return data
    },
    downTu(url) {
      // window.open(utils.getUrl() + url)
      //如果不包含等于 -1
      if (url.indexOf('http') == -1) {
        window.open(utils.getUrl() + url)
      } else {
        window.open(url)
      }
    },
    isContainUndefinedAnd(url) {
      if (!url) {
        return false
      }

      return (
        url.indexOf('undefined') == -1 &&
        url.indexOf('无资料请上传本图') == -1 &&
        url.indexOf('null') == -1 &&
        url != ''
      ) // 如果不包含就是true
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/gif' ||
        file.type === 'image/png' ||
        file.type === 'image/bmp'
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('上传文件只能上传图片格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    // 拷贝页面数据
    copyText(text) {
      var input = document.getElementById('inputbox')
      input.value = text // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$notify({
        title: '提示',
        message: '复制成功',
        type: 'success',
        duration: 2000
      })
    },
    copyJHWAll() {
      var input = document.getElementById('inputbox')
      input.value =
        '应付金额：' +
        this.payform.imoney +
        '元 ' +
        '\r\n' +
        '银行开户名：内蒙古中工保担保有限公司' +
        '\r\n' +
        '开户行：中国建设银行股份有限公司呼和浩特乌兰察布东街园艺御景支行' +
        '\r\n' +
        '银行账号：15050170661700000471' +
        '\r\n' +
        '转账必填，否则无效，不同银行名称不同，如“附言”、“用途”、“备注”、“摘要”等：' +
        this.payform.remark // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$notify({
        title: '提示',
        message: '复制成功',
        type: 'success',
        duration: 2000
      })
    },
    // 菜单事件
    clickdingdan(val) {
      // 投标保证保险
      if (val == 0) {
        this.msgk = 0
        this.canshu.itype = '4'
        this.getData()
        // 合同履约
      } else if (val == 1) {
        this.msgk = 1
        this.canshu.itype = '5'
        this.getData()
        // 预付款保证保险
      } else if (val == 2) {
        this.msgk = 2
        this.canshu.itype = '9'
        this.getData()
        // 农民工工资支付保证保险
      } else if (val == 3) {
        this.msgk = 3
        this.canshu.itype = '7'
        this.getData()
        // 工程款支付保证保险
      } else if (val == 4) {
        this.msgk = 4
        this.canshu.itype = '6'
        this.getData()
      }
    }
  }
}
</script>

<style scoped>
/* .container {
  margin: 20px 30px;
  text-align: left;
} */
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 20px;
}

.leftbars {
  position: relative;
  background-color: #f1f7fd;
  width: 220px;
  color: #333;
  height: calc(100vh - 228px);
  margin: 0;
  padding: 0px;
  text-align: center;
  border: 1px solid #d7e9fb;
}

.leftbars .bar {
  text-align: center;
  cursor: pointer;
  color: #fff;
  background-color: #1482f3;
  border-radius: 10px;
  margin: 15px;
  padding: 0;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
}

.leftbars .barb {
  background-color: #075ad3;
  border-radius: 10px;
  color: #a1e1f8;
  cursor: pointer;
  margin: 15px;
  padding: 0;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
}

.maincons {
  margin: 0;
  padding: 0 20px;
  flex: 1;
}

.maincons .buzhou {
  margin: 0px;
  padding: 0;
}

.dottits {
  font-size: 16px;
  font-weight: bold;
  border-left: 4px solid #f54737;
  background-color: #f2f2f2;
  padding: 2px 10px;
  margin: 10px 0;
}

.wraps {
  height: calc(100vh - 230px);
}

.wrap {
  padding: 10px 0px;
}

.wrap .el-tabs__item {
  background-color: #f2f2f2;
}

.wrap .is-active,
.wrap .el-tabs__item:hover {
  color: #f54737;
  font-weight: bold;
}

.wrap .is-active {
  color: #f54737;
  background-color: #fff;
}

.wrap .info {
  margin: 35px 0 0 15px;
}

/* 上传图片 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload .item {
  text-align: center;
  padding: 10px 10px 15px;
  background-color: #f2f2f2;
}

.upload h3 {
  margin-top: 0;
}

.upload .iconfont {
  font-size: 96px;
  color: #999;
}

.weixins {
  width: 650px;
  margin: 20px auto;
  padding: 0 0 0 50px;
}

.weixin {
  /* width: 50%; */
  display: inline-block;
  text-align: right;
  width: 150px;
}

.weixin img {
  /* margin: 0px auto; */
  width: 100%;
  height: 100%;
}

.weixintext {
  display: inline-block;
  vertical-align: top;
  width: 60%;
  font-size: 18px;
  line-height: 30px;
  padding: 15px 0 0 30px;
}

.tablem {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #999;
}

.tablem th,
.tablem td {
  border: 1px solid #ccc;
  padding: 0px 20px;
  height: 45px;
  min-width: 50px;
  line-height: 20px;
  font-size: 18px;
}

.yincangs {
  position: relative;
}

.yincang {
  -color: #fff;
  z-index: 0;
}

.yincangkuang {
  position: absolute;
  background-color: #fff;
  z-index: 8000;
  width: 100%;
  height: 100%;
}

.linkA {
  color: #4f8cfc !important;
}

.linkB {
  margin: 0 5px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/components/page/Order.vue